import { Injectable } from '@angular/core';
import { finalize, Observable, shareReplay } from 'rxjs';
import { ChatService } from './chat.service';
import { DOWNLOAD_MEDIA_TYPE } from '../enum/constants';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AvatarService {
  private downloadQueue = new Map<string, Observable<Blob>>();

  constructor(private readonly chatService: ChatService) {
  }

  getAvatarBlob(chat_id: string, media_id: string | number) {
    const key = `/${media_id}`;

    if (this.downloadQueue.has(key)) {
      return this.downloadQueue.get(key)!;
    }

    const fetch$ = this.chatService
      .downloadMedia(chat_id, media_id, DOWNLOAD_MEDIA_TYPE.PROFILE_PHOTO)
      .pipe(
        shareReplay(1),
        finalize(() => {
          this.downloadQueue.delete(key);
        }),
      );

    this.downloadQueue.set(key, fetch$);

    return fetch$;
  }
}
